import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import SuperUserLoanPageSF from '../../../templates/SuperUserLoanPageSF.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DsraEventListSF from '../../../components/superUser/loan/repayment/DsraEventListSF'
import './ReportCardPage.css'

const ReportCardPageUI = ({ context, errorList,
  loan, account, onRefreshClick,
  repayments, repaymentList,
  dsraEvent, dsraEventList,
  loanRemarksCs, monitoringRemarksList
}) =>
  <SuperUserLoanPageSF context={context} className='pg_su_repc'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='reportCard'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Report Card</b></span>
            </span>
          }
          right={<span />}
        />

        <div className='g_flex_h g_flex_top top_section'>
          <ReportCardUI
            loan={loan}
            account={account}
            context={context}
          />
          <TableUI
            context={context}
            repayments={repayments}
            repaymentList={repaymentList}
            onRefreshClick={onRefreshClick}
          />
        </div>
        <DsraEventListSF
          loan={loan}
          account={account}
          context={context}
          onRefreshClick={onRefreshClick}
          dsraEvent={dsraEvent}
          dsraEventList={dsraEventList}
        />
        <PenalChargesUI
          context={context}
          repayments={repayments}
          repaymentList={repaymentList}
          onRefreshClick={onRefreshClick}
        />
        <RemarksConditionSubsequentUI
          loan={loan}
          context={context}
          loanRemarksCs={loanRemarksCs}
        />
        <RemarksMonitoringUI monitoringRemarksList={monitoringRemarksList} />
      </div>
    }
  </SuperUserLoanPageSF>

const ReportCardUI = ({ loan, account }) =>
  <CardUI className='g_m_bottom_100'>
    <div className='g_flex_v'>
      <span className='g_flex_h'>App Downloaded <span>{account.dateCreatedF1}</span></span>
      <span className='g_flex_h'>Term Sheet Accepted <span>{loan.termSheet.acceptDateF1}</span></span>
      {
        loan.agreementSignList && loan.agreementSignList.length > 0 &&
        <span className='g_flex_h'>Loan Documents Signed
          <span>{loan.agreementSignList[loan.agreementSignList.length - 1].lenderSignDateF1}</span>
        </span>
      }
      {
        loan.disbursement.amountF2 &&
        <div>
          <span className='g_flex_h'>Disbursement Completed <span>{loan.disbursement.dateF1}</span></span>
          <span className='g_flex_h'>Loan Amount<span>{loan.disbursement.amountF2}</span></span>
        </div>
      }
      <span className='g_flex_h'>Loan Tenure <span>{loan.termSheet.tenureMonths} months</span></span>
      <span className='g_flex_h'>Interest Rate <span>{loan.termSheet.interestRateF} p.a.</span></span>
      <span className='g_flex_h'>Loan type
        <span>
          {loan.loanType === 'project' ? 'Amortized' : ''}
          {loan.loanType === 'interest_only' ? 'Interest only' : ''}
          {loan.loanType === 'int_then_prj' ? 'Hybrid' : ''}
          {loan.loanType === 'inv_discount' ? 'Receivable financing' : ''},
          {loan.loanType === 'lease' ? 'Lease' : ''}
        </span>
      </span>
    </div>
  </CardUI >

const TableUI = ({ repayments, repaymentList }) =>
  <CardUI className='g_m_left_100 g_m_bottom_100'>
    <table className='g_m_bottom_100'>
      <thead><tr>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>Scheduled</b></td>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>EMI</b></td>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>To Collect</b></td>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>Status</b></td>
      </tr></thead>
      <tbody>
        {
          repaymentList && repaymentList.map((repayment, i) =>
            <RepaymentRowUI key={i} repayment={repayment}
            />
          )
        }
      </tbody>
    </table>
    <table>
      <thead><tr>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>Total EMI</b></td>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>Total EMI paid</b></td>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>Total EMI left</b></td>
      </tr></thead>
      <tbody>
        {
          repayments &&
          <>
            <RowUI
              value={repayments.totalEMIF2}
              value1={repayments.totalEMIPaidF2}
              value2={repayments.totalEMILeftF2}
            />
          </>
        }
      </tbody>
    </table>
  </CardUI>

const PenalChargesUI = ({ repaymentList }) =>
  <CardUI className='g_m_top_100' title='Penal charges'>
    <table className='g_m_bottom_100'>
      <thead><tr>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>Scheduled</b></td>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>DSRA Dip Penalty</b></td>
        <td className='g_text_center'>
          <b className='g_m_left_50 g_m_right_50'>Penal Charge</b></td>
      </tr></thead>
      <tbody>
        {
          repaymentList && repaymentList.map((repayment, i) =>
            <PenalChargesRowUI key={i} repayment={repayment}
            />
          )
        }
      </tbody>
    </table>
  </CardUI>

const RemarksConditionSubsequentUI = ({ loan, loanRemarksCs }) =>
  <CardUI className='g_m_top_100' title='Compliance'>
    <LRTableBodyUI>
      {
        loan.fileUpload3List.map((file, i) =>
          <LRTableRowUI key={i} className='g_flex_top'
            left={<RowLeftUI file={file} i={i} loanRemarksCs={loanRemarksCs} />}
            right={<CSRowRightUI file={file} />}
          />
        )
      }
    </LRTableBodyUI>
  </CardUI >

const RemarksMonitoringUI = ({ monitoringRemarksList }) =>
  <CardUI className='g_m_top_100' title='Monitoring remarks'>
    {
      monitoringRemarksList && monitoringRemarksList.map((remarks, i) =>
        <div key={i}>
          <span className='g_m_left_100 g_muted'>{remarks.remarksDateF}: {remarks.remarks}</span>
        </div>
      )
    }
  </CardUI >

const RepaymentRowUI = ({ repayment, i }) =>
  <>
    <tr key={i}>
      <td className='g_text_right'>
        <span className='g_no_wrap_2'>{repayment.scheduledDateF1}</span>
      </td>
      <td className='g_text_right'>
        <span className='g_m_left_100'>{repayment.emiF5}</span>
      </td>
      <td className='g_text_right'>
        <span className='g_m_left_50'>{repayment.emiWithLateInterestAndTaxF5}</span>
      </td>
      <td className='g_text_right'>
        <span className='g_m_left_50'>{repayment.status}</span>
      </td>
    </tr>
  </>

const RowUI = ({ value, value1, value2, total }) =>
  <>
    <tr className={total && 'g_table_total'}>
      <td className='g_text_right'>
        {value}
      </td>
      <td className='g_text_right'>
        {value1}
      </td>
      <td className='g_text_right'>
        {value2}
      </td>
    </tr>
  </>

const PenalChargesRowUI = ({ repayment, i }) =>
  <>
    {
      repayment.scheduledDate <= new Date().getTime() &&
      <tr key={i}>
        <td className='g_text_right'>
          <span className='g_no_wrap_2'>{repayment.scheduledDateF1}</span>
        </td>
        <td className='g_text_right'>
          <span className='g_m_left_100'>
            {repayment.dsraDipInterestWaived ? 'waived' : repayment.drsaDipInterestF5}
          </span>
        </td>
        <td className='g_text_right'>
          <span className='g_m_left_50'>{repayment.defaultInterestF5}</span>
        </td>
      </tr>
    }
  </>

const RowLeftUI = ({ i, loanRemarksCs, file }) =>
  <div className='g_flex_h g_flex_top'>
    <span>{i + 1}</span>
    <div className='g_flex_v g_m_left_100'>
      <span key={i}>{file.fileTitle} </span>
      {
        loanRemarksCs &&
        <table className='table_report'>
          {
            loanRemarksCs.filter(r => r.objectId === file.fileCode).map((remarks, j) =>
              <tbody key={j}>
                {
                  (remarks.status === 'complied' || remarks.status === 'not_complied') &&
                  <tr>
                    <td className='g_muted g_no_wrap_2'>{remarks.remarksDateF}<br />
                      {
                        remarks.status &&
                        <BadgeUI className='g_m_right_50' label={remarks.status} />
                      }
                    </td>
                    <td className='g_muted'>{remarks.remarks}</td>
                  </tr>
                }
              </tbody>
            )
          }
        </table>
      }
    </div>
  </div>

const CSRowRightUI = ({ file }) =>
  <div className='g_flex_v'>
    {
      file.internalStatus &&
      <span className='g_m_left_50'><BadgeUI label={file.internalStatus} /></span>
    }
  </div>

export default ReportCardPageUI
